import React from 'react'
import ActuatorOption from './ActuatorOption'
import { Toggle } from 'src/Libs/inputs/react-hook-form'

const ActuatorAutoOption: React.FC = () => {
  return (
    <ActuatorOption title={'smart-home.common.automation.title'} description={'smart-home.common.automation.description'} breakOnMobile={false}>
      <Toggle name="auto" />
    </ActuatorOption>
  )
}

export default ActuatorAutoOption
